import React, { useCallback, useEffect, useState } from 'react';
import '@ant-design/compatible/assets/index.css';
import moment from 'moment';
import {
  Form,
  Tabs,
  Col,
  Row,
  Checkbox,
  Typography,
  Collapse,
  notification,
  DatePicker,
} from 'antd';
import _ from 'lodash';

import DF from 'DisplayFramework';
import Text from 'components/Text';
import ParListSelect from 'components/ParListSelect';
import { getProposalById, getProposalUsedAmounts } from 'services/proposal';
import { toCurrency } from 'utils/utils';
import GetLabel from 'DisplayFramework/components/GetLabel';
import LoanRedemption from 'pages/ProposalV3/PropDetail/LoanRedemption';
import Value from 'components/Value';
import { toDatePickerDate } from 'utils/utils2';

const { TabPane } = Tabs;
const { Text: AntText } = Typography;
const { Panel } = Collapse;

const TabLoanActivationCtRedemption = (props: any) => {
  props.form?.setFieldsValue({
    event: 'tabLoanActivationCtRedemption',
    flagredemption: true,
  });

  const [state, setState] = useState<any>({
    FIN: [],
    ElementFIN: {},
    currcode: '',
    investamount: 0,
    upfrontamount: 0,
    finamount: 0,
  });

  const initValues = useCallback(() => {
    props.form.setFieldsValue({
      invoiceParticipation: true,
      invoiceUpfront: true,
      invoiceDeferredinterest: true,
      invoiceDeposit: true,
      invoiceFirstrental: true,
      generateDisbursment: true,
      generateCommission: true,
      activationMode: 'FIN',
    });
  }, [props.form]);

  const updateState = useCallback(
    (values) => {
      setState((prev: any) => ({ ...prev, ...values }));
    },
    [setState]
  );

  const loadCTDetail = (ctrid: number) => {
    // props.setSuccessful(true);

    getProposalById({ ctrid }).then((response) => {
      const proposal = response.data;

      // eslint-disable-next-line no-debugger
      //debugger;

      const ElementsFin = proposal?.conElements.filter(
        (e) => e.ctetype === 'FIN'
      );

      const investAmount = _.sumBy(ElementsFin, 'cteinvestamount');
      const finAmount = _.sumBy(ElementsFin, 'ctefinancedamount');
      const upFrontAmount = _.sumBy(ElementsFin, 'cteupfrontamount');
      const partAmount = _.sumBy(ElementsFin, 'ctepartamount');
      const depositAmount = _.sumBy(ElementsFin, 'ctedepositamount');

      const elemFin = ElementsFin[0];

      getProposalUsedAmounts({ ctrid }).then((response2) => {
        const usedAmounts = response2.data;
        props.form.setFieldsValue({
          investAmountUsed: usedAmounts?.finamountused,
          investAmount: investAmount - usedAmounts?.finamountused,
          finAmount: investAmount - usedAmounts?.finamountused,
        });
      });

      const conLoanRedemp = proposal?.conLoanRedemption;
      props.form.setFieldsValue({
        event: 'tabLoanActivationCtRedemption',
        partAmount: elemFin!.ctepartamount,
        depositAmount: elemFin!.ctedepositamount,
        upfrontAmount: elemFin!.cteupfrontamount,
        startDate:
          props.form.getFieldValue('startDate') ??
          moment(new Date(), 'YYYY-MM-DD'),
        billingDate: elemFin!.ctebilligdate,
        ctduration: elemFin!.cteduration,
        listAsset: '',
        // activationMode: 'PREFIN',
        prefinmethod: elemFin!.prefinmethod,
        prefinbasis: elemFin!.prefinbasis,
        prefinperiodicity: elemFin!.prefinperiodicity,
        prefinnominalrate: elemFin!.prefinnominalrate,

        prefinratespread: elemFin!.prefinratespread,
        prefinrateref: elemFin!.prefinrateref,

        prefinrateformula: elemFin!.prefinrateformula,
        prefinratetype: elemFin!.prefinratetype,

        generateDisbursment: props.form.getFieldValue('generateDisbursment'),
        offerid: proposal?.offerid,
        prcode: proposal?.prcode,
        conLoanRedemption: conLoanRedemp?.map((e) => {
          return {
            ...e,
            ctredstartdate: toDatePickerDate(e.ctredstartdate) ?? null,
            ctredenddate: toDatePickerDate(e.ctredenddate) ?? null,
            ctredvaliditydate: toDatePickerDate(e.ctredvaliditydate) ?? null,
            tpredbenef:
              typeof e.tpredbenef == 'object'
                ? ('' as any)
                : {
                    tpid: e.tpredbenef ? e.tpredbenef : 0,
                    tpname: e.tpredbenefname ? e.tpredbenefname : '',
                    tpreference: e.tpredbenefreference
                      ? e.tpredbenefreference
                      : '',
                  },
            ctridlinked:
              e.ctredtype === 'INTERNAL'
                ? {
                    ctrid: e.ctridlinked,
                    propreference: e.ctredreference,
                    clientname: proposal?.clientname,
                  }
                : e.ctridlinked,
            // tpofformula: e.tpofformula,
          };
        }),
      });
      let isValid = true; 
      conLoanRedemp.forEach((e: any) => {
        const ctredValidityDate = moment(toDatePickerDate(e.ctredvaliditydate));
        const startDate = moment(props.form.getFieldValue('startDate'));

        if (startDate.isAfter(ctredValidityDate)) {
          // props.setSuccessful(false);
          isValid=false;
          notification.error({
            message:
              'La date d’activation du rachat doit être inférieure ou égale à la date de validité.',
          });
        }
      });

      updateState({
        currcode: proposal.currcode,
        rentalamount: 0,
        rentalamountinit: elemFin!.cterentalamount,
        investamount: investAmount,
        upfrontAmount: upFrontAmount,
        finamount: finAmount,
        investamountinit: proposal.ctfinancedamount,
        // FIN: [elemFin],
      });

      if (proposal.ctstatus !== 'ACTIVE') {
        isValid=false
        // props.setSuccessful(false);
      }
      console.log('valid::',isValid)
      props.setSuccessful(isValid);
    });
  };
  const toDateString = (momentOrString: any) =>
    momentOrString === undefined
      ? ''
      : typeof momentOrString === 'string'
      ? momentOrString
      : momentOrString.format('YYYY-MM-DD');

  useEffect(() => {
    // props.form.setFieldValue('activationMode', 'FIN');
    loadCTDetail(props.objectid);
    initValues();
  }, [initValues]);

  return (
    <DF.Provider pagcode="tabloanactivationatredemption">
      <Form
        form={props.form}
        layout="horizontal"
        labelAlign="left"
        onValuesChange={(changedValues) => {
          if (changedValues.startDate) {
            console.log('startDate mis a jour :', changedValues.startDate);
            loadCTDetail(props.objectid);
          }
        }}
      >
        <Form.Item shouldUpdate noStyle>
          {({ getFieldValue }) => (
            <Tabs animated defaultActiveKey="1">
              <TabPane
                tab={<GetLabel label="FinActivation" />}
                key={1}
                forceRender
              >
                <Row gutter={[8, 8]}>
                  <Col span={6} />
                  <Col span={4}>
                    <Text comcode="investAmount" />
                  </Col>
                  <Col span={4}>
                    <Form.Item style={{ margin: 0 }} name="investAmount">
                      <Value
                        formatter={(val) => toCurrency(val, state.currcode)}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={5} />
                </Row>
                <Row gutter={[8, 8]}>
                  <Col span={6} />
                  <Col span={4}>
                    <Text comcode="upfrontAmount" />
                  </Col>
                  <Col span={4}>
                    <Form.Item style={{ margin: 0 }} name="upfrontAmount">
                      <Value
                        formatter={(val) => toCurrency(val, state.currcode)}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={5}>
                    <Form.Item
                      style={{ margin: 0 }}
                      name="invoiceUpfront"
                      valuePropName="checked"
                    >
                      <Checkbox defaultChecked>
                        <Text comcode="flagupfront" />
                      </Checkbox>
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={[8, 8]}>
                  <Col span={6} />
                  <Col span={4}>
                    <Text comcode="finAmount" />
                  </Col>
                  <Col span={4}>
                    <Form.Item style={{ margin: 0 }} name="finAmount">
                      <Value
                        formatter={(val) => toCurrency(val, state.currcode)}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={5}>
                    <Form.Item
                      style={{ margin: 0 }}
                      name="generateDisbursment"
                      valuePropName="checked"
                    >
                      <Checkbox
                        defaultChecked
                        onChange={(a) => {
                          props?.form.setFieldValue(
                            'generateDisbursment',
                            a.target.checked
                          );
                        }}
                      >
                        <Text comcode="generateDisbursment" />
                      </Checkbox>
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={[8, 8]}>
                  <Col span={6} />
                  <Col span={4}>
                    <Text comcode="partAmount" />
                  </Col>
                  <Col span={4}>
                    <Form.Item style={{ margin: 0 }} name="partAmount">
                      <Value
                        formatter={(val) => toCurrency(val, state.currcode)}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={5}>
                    <Form.Item
                      style={{ margin: 0 }}
                      name="invoiceParticipation"
                      valuePropName="checked"
                    >
                      <Checkbox defaultChecked>
                        <Text comcode="flagpart" />
                      </Checkbox>
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={[8, 8]}>
                  <Col span={6} />
                  <Col span={4}>
                    <Text comcode="depositAmount" />
                  </Col>
                  <Col span={4}>
                    <Form.Item style={{ margin: 0 }} name="depositAmount">
                      <Value
                        formatter={(val) => toCurrency(val, state.currcode)}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={5}>
                    <Form.Item
                      style={{ margin: 0 }}
                      name="invoiceDeposit"
                      valuePropName="checked"
                    >
                      <Checkbox defaultChecked>
                        <Text comcode="flagdeposit" />
                      </Checkbox>
                    </Form.Item>
                  </Col>
                </Row>

                <Row gutter={[8, 8]}>
                  <Col span={6} />
                  <Col span={4}>
                    <Text comcode="startDate" />
                  </Col>
                  <Col span={4}>
                    <Form.Item style={{ margin: 0 }} name="startDate">
                      <DatePicker />
                    </Form.Item>
                  </Col>
                  <Col span={5} />
                </Row>
                <Row gutter={[8, 8]}>
                  <Col span={6} />
                  <Col span={4}>
                    <Text comcode="billingdate" />
                  </Col>
                  <Col span={4}>
                    <Form.Item style={{ margin: 0 }} name="billingDate">
                      <ParListSelect parcode="BILLDATE" />
                    </Form.Item>
                  </Col>
                  <Col span={5}>
                    <Form.Item
                      style={{ margin: 0 }}
                      name="invoiceDeferredinterest"
                      valuePropName="checked"
                    >
                      <Checkbox defaultChecked>
                        <Text comcode="flagdeferredinterest" />
                      </Checkbox>
                    </Form.Item>
                  </Col>
                </Row>

                <Row gutter={[8, 8]}></Row>

                <Row>
                  <LoanRedemption form={props.form} hideButton />
                </Row>
              </TabPane>
            </Tabs>
          )}
        </Form.Item>
      </Form>
    </DF.Provider>
  );
};
export default TabLoanActivationCtRedemption;
